<template>
  <div class="dialog-box">
    <div class="dialog-1" v-if="showMessage&&!selectedId">
      <div class="title">评价反馈
        <i class="iconfont icon-guanbi title-close" @click="handleClose"></i>
      </div>
      <div class="content">
        <div class="content-title">非常感谢您的使用，欢迎您对我们的产品进行评价</div>
        <ul class="rate-ul">
          <li class="rate-li" v-for="item in rateData" :key="item.value" @mouseout="handleMouseOut(item.value)" @mouseover="handleMouseOver(item.value)" @click="handleMouseClick(item.value)">
            <div class="rate-icon" :class="item.value <= hoverId ? 'rate-active' : ''">
              <i class="iconfont icon-star"></i>
            </div>
            <div class="rate-text" :class="item.value <= hoverId ? 'rate-active' : ''">
              {{item.label}}
            </div>
          </li>
          
        </ul>
      </div>
    </div>
    <div class="zhezhao" v-if="showMessage&&selectedId">
      <div class="dialog-2">
        <div class="title">评价反馈
          <i class="iconfont icon-guanbi title-close" @click="handleClose"></i>
        </div>
        <div class="content">
          <div class="content-title">非常感谢您的使用，欢迎您对我们的产品进行评价</div>
          <ul class="rate-ul">
            <li class="rate-li" v-for="item in rateData" :key="item.value" @mouseout="handleMouseOut(item.value)" @mouseover="handleMouseOver(item.value)" @click="handleMouseClick(item.value)">
              <div class="rate-icon" :class="item.value <= hoverId ? 'rate-active' : ''">
                <i class="iconfont icon-star"></i>
              </div>
              <div class="rate-text" :class="item.value <= hoverId ? 'rate-active' : ''">
                {{item.label}}
              </div>
            </li>
          </ul>
        </div>
        <div class="content-text">
          <div class="content-title">我们非常在意您的心声，可以在此留下您的意见和建议</div>
          <el-input
    v-model="advice"
    class="resizeNone"
    style="width: 100%;"
    :rows="5"
    type="textarea"
    placeholder="请描述您的需求场景与改进建议"
  />
        </div>
        <div class="but">
          <el-button type="primary" class="submit-but" @click="submitInfo">提交</el-button>
        </div>
      </div>
    </div>
  </div>
  

</template>
<script>

import { addEvalFeedBack } from "@/api/common";

import {mapMutations, mapState} from "vuex";
export default {
  computed:{
    ...mapState("user",['userAccount'])
  },
  data() {
    return {
      advice: '',
      showMessage: false,
      timer:null,
      selectedId: 0,
      hoverId: 0,
      rateData: [{
          label:'非常不满意',
          value:1
        },{
          label:'不满意',
          value:2
        },{
          label:'一般',
          value:3
        },{
          label:'满意',
          value:4
        },{
          label:'非常满意',
          value:5
      }]
    }
  },
  mounted() {
    // 启动定时器
    this.timer = setTimeout(() => {
      this.showMessage = true;
    }, 60000) // 每1000毫秒调用一次yourMethod方法
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer=null
  },
  methods:{
    open(){
      this.showMessage = true;
    },
    async submitInfo(){
          const json = {
      star: this.selectedId,
      bussiness:'bswjjc',
      productModule: 'duplicates',
      advice: this.advice,
      userAccount: this.userAccount
      
    }
    const res = await addEvalFeedBack(json);
    if(res.data){
      this.$message({
        message: '您已提交成功，感谢您的帮助与支持！',
        type: 'success',
        duration: 5000
      })
      this.showMessage = false;
      this.advice = '';
      this.selectedId = 0;
      this.hoverId = 0;
    }
    },
    handleClose(){
      this.showMessage = false;
      this.advice = '';
      this.selectedId = 0;
      this.hoverId = 0;
    },
    handleMouseOut(){
      this.hoverId = this.selectedId;
    },
    handleMouseOver(val){
      this.hoverId = val
    },
    handleMouseClick(val){
      this.selectedId = val;
    }
  }
}

//   import { addEvalFeedBack } from '@/api/bsjc'

//   import { ref, onMounted, onUnmounted } from 'vue';

//   import { ElMessage } from 'element-plus';

//   import { storeToRefs } from 'pinia';

//   import useUserStore from "@/store/userStore";

//   const userStore = useUserStore();

//   const { userInfo } = storeToRefs(userStore);
//   const advice = ref('');

  
//   const timer = ref();

  
//   const showMessage = ref(false);

//   onMounted(() => {
//     timer.value = setTimeout(() => {
//       showMessage.value = true;
//     }, 60000)
//   });



//   const submitInfo = async() => {
//     const json = {
//       star: selectedId.value,
//       bussiness:'bswjjc',
//       productModule: 'review',
//       advice: advice.value,
//       userAccount: userInfo.value.useraccount
      
//     }
//     const res = await addEvalFeedBack(json);
//     if(res.data){
//       ElMessage({
//         message: '您已提交成功，感谢您的帮助与支持！',
//         type: 'success',
//         duration: 5000
//       })
//       showMessage.value = false;
//       advice.value = '';
//       selectedId.value = 0;
//       hoverId.value = 0;
//     }
    
//   };

//   const open = () => {
//     showMessage.value = true;
//   }

//   const handleClose = () => {
//     showMessage.value = false;
//     advice.value = '';
//     selectedId.value = 0;
//     hoverId.value = 0;
//   }

//   //在页面销毁之前先销毁定时器
//   onUnmounted(() => {
//     clearTimeout(timer.value)
//     timer.value=""
//   })

//   const rateData:any = [{
//     label:'非常不满意',
//     value:1
//   },{
//     label:'不满意',
//     value:2
//   },{
//     label:'一般',
//     value:3
//   },{
//     label:'满意',
//     value:4
//   },{
//     label:'非常满意',
//     value:5
//   }];

//   const hoverId = ref<number>(0);

//   const selectedId = ref<number>(0);

//   const handleMouseOver = (val:number) => {
//     hoverId.value = val;
//   }

//   const handleMouseOut = (val:number) => {
//     hoverId.value = selectedId.value;
//   }

//   const handleMouseClick = (val:number) => {
//     selectedId.value = val;
//   }
  
// defineExpose({
//   open
// });
</script>
<style lang="scss">
.resizeNone{
   .el-textarea__inner{ //el_input中的隐藏属性
         resize: none;  //主要是这个样式
     }
     
 }
</style>
<style lang="scss" scoped>
.submit-but{
  width:100%;
  border-radius:16px;
}
  .zhezhao{
    position:fixed;
    left:0;
    right:0;
    top:0;
    z-index:10000;
    bottom:0;
    margin:auto;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    .dialog-2{
      width:420px;
      height:464px;
      position:fixed;
      box-sizing:border-box;
      border-radius:4px;
      padding:24px;
      left:0;
      right:0;
      top:0;
      bottom:0;
      margin:auto;
      background-image: url("~@/assets/image/feedback-bj-2.jpg");
      background-size:100% 100%;
      .title{
        font-size:16px;
        font-weight:bold;
        text-align:center;
        color:#1F2329;
        position:relative;
        .title-close{
          position:absolute;
          right:0;
          top:0;
          bottom:0;
          margin:auto;
          cursor:pointer;
        }
        margin-bottom:12px;
      }
      .content-text{
        height:186px;
        width:100%;
        box-sizing:border-box;
        background:#FFFFFF;
        border-radius:4px;
        padding:16px;
        margin-bottom:24px;
        .content-title{
          color:#1F2329;
          font-size:14px;
          margin-bottom:15px;
        }
      }
      .content{
        height:124px;
        width:100%;
        background:#FFFFFF;
        border-radius:4px;
        box-sizing:border-box;
        padding:16px;
        margin-bottom:12px;
        .content-title{
          color:#1F2329;
          font-size:14px;
          margin-bottom:15px;
        }
        .rate-ul{
          display:flex;
          height:56px;
          list-style-type: none;
          .rate-li{
            width:0;
            list-style-type: none;
            flex:1;
            .rate-icon{
              height:30px;
              line-height:30px;
              text-align:center;
              margin-bottom:8px;
              color:#DEE0E3;
              .icon-star{
                font-size:28px;
                
              }
              
            }
            .rate-text{
              font-size:12px;
              color:#646A73;
              text-align:center;
            }
            cursor:pointer;
            .rate-active{
              color:#3973FF;
            }


          }
        }
      }
    }
  }
  
  .dialog-1{
    width:420px;
    z-index:10000;
    height:212px;
    position:fixed;
    box-sizing:border-box;
    border-radius:4px;
    padding:24px;
    right:12px;
    bottom:6px;
    background-image: url("~@/assets/image/feedback-bj-1.jpg");
    background-size:100% 100%;
    .title{
      font-size:16px;
      font-weight:bold;
      text-align:center;
      color:#1F2329;
      position:relative;
      .title-close{
        position:absolute;
        right:0;
        top:0;
        bottom:0;
        margin:auto;
        cursor:pointer;
      }
      margin-bottom:12px;
    }
    .content{
      height:124px;
      width:100%;
      background:#FFFFFF;
      border-radius:4px;
      box-sizing:border-box;
      padding:16px;
      .content-title{
        color:#1F2329;
        font-size:14px;
        margin-bottom:15px;
      }
      .rate-ul{
        display:flex;
        height:56px;
        list-style-type: none;
        .rate-li{
          width:0;
          flex:1;
          .rate-icon{
            height:30px;
            line-height:30px;
            text-align:center;
            margin-bottom:8px;
            color:#DEE0E3;
            .icon-star{
              font-size:28px;
              
            }
            
          }
          .rate-text{
            font-size:12px;
            color:#646A73;
            text-align:center;
          }
          cursor:pointer;
          .rate-active{
            color:#3973FF;
          }


        }
      }
    }
  }
</style>